import { FormattedMessage } from 'react-intl';

import { Loader } from '@/components/global/Loader';

export const GithubInstallationPending = (): JSX.Element => (
  <main className="flex items-center flex-col justify-center w-screen h-screen bg-zinc-50 dark:bg-zinc-900">
    <Loader />
    <h1 className="text-xl mb-2 mt-4">
      <FormattedMessage id="githubCallback.loader.title" />
    </h1>
    <h2 className="text-gray-400">
      <FormattedMessage id="githubCallback.loader.subtitle" />
    </h2>
  </main>
);
